import React, { Component } from "react";

import AdminLink from "../app/AdminLink";

export default class Users extends Component {
  render() {
    return (
      <div className="users">
        <AdminLink />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/merchant/Users.js